import { useState } from "react"
import DP from "../../../components/custom/dp"
import Icon from "../../../components/custom/icon"
import Dropdown from "../../../components/custom/input/types/dropdown"
import "./index.css"

export const MemberSearch = ({ member, onClick }) => {
    const { name, phone, courseID } = member

    const handleClick = () => {
        onClick(member)
    }

    return (
        <div onClick={handleClick} className="flex-row flex-space-between flex-align-center att-mem-root">
            <div className="flex-row flex-align-center">
                <DP user={member} size={15} enlarge />
                <div className="flex-col att-mem-data">
                    <div className="att-mem-name bold">{name}</div>
                    <div className="att-mem-phone">{phone}</div>
                </div>
            </div>
            <div>{courseID}</div>
        </div>
    )
}

export const MemberSelect = ({ member, events, onClear, onSelect }) => {
    const { name, phone, courseID } = member

    var defEvent = events[0].name
    for (let i = 0; i < events.length; i++) {
        if (events[i].courseID == courseID) {
            defEvent = events[i].value
            break
        }
    }

    const [selectedEvent, setSelectedEvent] = useState(defEvent)

    return (
        <div className="flex-col">

            <div className="flex-row flex-space-between flex-align-center att-mem-sel-root">

                <div className="flex-row flex-align-center att-memsel-info">
                    <DP user={member} size={15} enlarge />
                    <div className="flex-col att-mem-data">
                        <div className="att-mem-name bold">{name || 'No Name'}</div>
                        <div className="att-mem-phone">{phone}</div>
                    </div>
                </div>
            </div>

            <div className="relative flex-col att-mem-event-cont">
                <div className="att-mem-event-label">Session/Event</div>
                <div className="att-mem-event">
                    <Dropdown className="att-mem-eventdrop" options={events} def={defEvent} onChange={setSelectedEvent} />
                </div>
            </div>

            <div className="flex-row flex-space-between">
                <div className="att-memsel-button att-memsel-cancel" onClick={onClear}>Cancel</div>
                <div className="att-memsel-button att-memsel-mark" onClick={() => onSelect(member, selectedEvent)}>Mark</div>
            </div>

        </div>

    )
}

export const MemberAttendance = ({ member, onClear, onSelect }) => {
    const { name, phone, courseID, eventName, time } = member

    return (
        <div className="flex-row flex-space-between flex-align-center att-mem-root">

            <div className="flex-row flex-align-center att-mem-info">
                <DP user={member} size={15} enlarge />
                <div className="flex-col att-mem-data">
                    <div className="att-mem-name bold">{name || 'No Name'}</div>
                    <div className="att-mem-phone">{courseID || eventName}</div>
                </div>
            </div>

            <div className="flex-row flex-space-between att-mem-right">
                <Icon className="att-mem-edit" name="edit" size={7} color="#888" onClick={() => onSelect(member)} />
                <div className="flex-col att-mem-last flex-space-between flex-align-end">
                    <Icon name="close" size={3} color="#555" onClick={onClear} />
                    <div className="att-mem-time">{time}</div>
                </div>
            </div>
        </div>
    )
}